/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'magnify': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 14.862l-4.379-4.379a6.509 6.509 0 10-1.148 1.148l4.379 4.379zm-9.507-3.486a4.873 4.873 0 113.445-1.427 4.843 4.843 0 01-3.446 1.427z" _fill="#a7a7a7" fill-rule="evenodd"/>'
  }
})
